module.exports = __webpack_public_path__ + "img/banner_font.1cdef847.png";